window.keyMessageBannerScroller = function keyMessageBannerScroller() {

    var key_message_scroller = $('.keyMessageBanner .wrapper');

    if ($(window).width() > 1196 || $(window).width() < 681) {

        if (key_message_scroller.hasClass('slick-initialized')) {
            key_message_scroller.slick('unslick');
            $('.column').matchHeight();
        }

    } else if ($(window).width() < 670) {

        if (key_message_scroller.hasClass('slick-initialized')) {
            key_message_scroller.slick('unslick');
            $('.column').matchHeight();
        }

    } else if (!key_message_scroller.hasClass('slick-initialized') && $('.keyMessageBanner .wrapper .column').length > 1) {
        key_message_scroller.slick({
            infinite: true,
            dots: false,
            arrows: false,
            autoplay: true
        });
    }
}

/*
 * Remove horizontal scrollbar function
 */

function removeHorzScrollBar(parent, active_link, offset) {

    if ($(parent).length) {
        var container = $(parent),
            scrollbar_height = container.outerHeight() - container.prop("clientHeight");

        // calculate scrollbar height and apply margin to offset padding
        container.css({
            'margin-bottom': -scrollbar_height - 20
        });
        console.log('has scrollbar');
    }
}

/* ------------------------------ */
/* Fuzzy animations */

/* ------------------------------ */

window.fuzzyBounceClass = function fuzzyBounceClass() {
    'use strict';

    $('.fuzzyRollWrap .fuzzyWrap .fuzzy, .fuzzyRollWrap .fuzzyWrap .mobileFuzzy').on('mouseenter mouseleave', function () {
        $(this).addClass("bounceMe").delay(3000).queue(function (next) {
            $(this).removeClass("bounceMe");
            next();
        });
    });

    $('.fuzzyBuyWrap .fuzzyWrap .fuzzy').on('mouseenter mouseleave', function () {
        $(this).addClass("bounceMe").delay(2000).queue(function (next) {
            $(this).removeClass("bounceMe");
            next();
        });
    });

    $('.fuzzyRollWrap .fuzzyWrap .fuzzy, .fuzzyRollWrap .fuzzyWrap .mobileFuzzy').on('click', function () {
        $(".speechBubbleWrap").toggleClass("showMe");
    });

    $('.fuzzyTopBanner .fuzzy').on('click', function () {
        $(this).parents(".fuzzyTopBanner").find('.js_fuzzyVideoOverlay').trigger('click');
    });

    $('.fuzzyRollWrap .speechBubbleWrap .closeMe').on('click', function () {
        $(this).parents(".fuzzyRollWrap").fadeOut();
    })

    if ($('.fuzzyRollWrap .speechBubbleWrap') && $(window).width() > window.breakpoints.mobile) {
        $('.fuzzyRollWrap .speechBubbleWrap').delay(3800).queue(function (next) {
            $(this).addClass("showMe");
            next();
        });
    }
    ;


}


/* ------------------------------ */
/* Paralax image new car page changing image on mobile */

/* ------------------------------ */

window.paralaxImageChange = function paralaxImageChange() {
    'use strict';

    var mobile_image,
        desktop_image;

    if ($(window).width() > window.breakpoints.mobile) {
        desktop_image = $('.fullWidthFeature .bannerImage').data('desktop');

        $('.fullWidthFeature .bannerImage').css({
            'background-image': 'url(' + desktop_image + ')'
        });
    } else {
        mobile_image = $('.fullWidthFeature .bannerImage').data('mobile');

        $('.fullWidthFeature .bannerImage').css({
            'background-image': 'url(' + mobile_image + ')'
        });
    }
}

/* ------------------------------ */
/* chaging directions wherabouts on mobile */
/* ------------------------------ */


/* ------------------------------ */
/* SVG Support */

/* ------------------------------ */

window.supportsSVG = function supportsSVG() {
    'use strict';
    return !!document.createElementNS && !!document.createElementNS('http://www.w3.org/2000/svg', "svg").createSVGRect;
}

window.loadSVGs = function loadSVGs() {

    'use strict';

    if (supportsSVG() && !$('html').hasClass('lt-ie9')) {

        $('.siteOuterWrapper').addClass('svg');

        $('.svgImage').each(function () {

            $(this).hide();

            var src = $(this).attr("src"),
                $img = $(this),
                imgID = $img.attr('id'),
                imgClass = $img.attr('class'),
                imgURL = '',
                timer = '';

            if (typeof src !== "undefined") {
                $(this).attr("src", src.replace(/png/, 'svg'));
            }

            imgURL = $img.attr('src');

            timer = setTimeout(function () {

                $.get(imgURL, function (data) {
                    // Get the SVG tag, ignore the rest
                    var $svg = $(data).find('svg');

                    // Add replaced image's ID to the new SVG
                    if (typeof imgID !== 'undefined') {
                        $svg = $svg.attr('id', imgID);
                    }
                    // Add replaced image's classes to the new SVG
                    if (typeof imgClass !== 'undefined') {
                        $svg = $svg.attr('class', imgClass + ' replaced-svg');
                    }

                    // Remove any invalid XML tags as per http://validator.w3.org
                    $svg = $svg.removeAttr('xmlns:a');

                    // Replace image with new SVG
                    $img.replaceWith($svg);

                }, 'xml');

                $(this).show();

            }, 0);

        });

    } else {
        $('.svgImage').each(function () {
            if (typeof $(this).attr("src") !== "undefined") {
                $(this).attr("src", $(this).attr("src").replace(/.svg/, '.png'));
            }
        });
    }
}

/**
 *  Item page special offers slider
 */
window.itemSpecialOffers = function itemSpecialOffers() {
    /*
    if ($('.js_specialOffersSlider .specialOffersSlide').length > 1) {
        $('.js_specialOffersSlider').slick({
            arrows : true,
            nextArrow: '<a class="slick-next"><i class="fa fa-angle-right" aria-hidden="true"></i></a>',
            prevArrow: '<a class="slick-prev"><i class="fa fa-angle-left" aria-hidden="true"></i></a>',
        });
    }*/
}

/* ------------------------------ */
/* News Article Loader  */

/* ------------------------------ */

window.loadNewsArticles = function loadNewsArticles(noAnimation) {

    'use strict';

    var ajaxURL,
        siteName = $('body').attr('data-site'),
        last_page_result,
        category_id,
        section_title,
        animationSpeed,
        filter_from,
        filter_to,
        tag,
        last_page;

    ajaxURL = '/sites/' + siteName + '/templates/ajax/news-list.php';

    $('#loadingOverlay').fadeIn();

    if ($('.newsList li').last().attr('data-page')) {
        last_page_result = $('.newsList li').last().data('page')
    } else {
        last_page_result = 0;
    }

    category_id = $('.newsArticles').data('category');
    section_title = $('.newsArticles').data('section-title');
    filter_from = $('.newsArticles').data('filter_from');
    filter_to = $('.newsArticles').data('filter_to');
    tag = $('.newsArticles').data('tag');

    if (noAnimation === true) {
        animationSpeed = 0;
    } else {
        animationSpeed = 1500;
    }

    $.ajax({
        type: 'post',
        url: ajaxURL,
        dataType: 'json',
        data: {
            ajax: true,
            listing_page: last_page_result + 1,
            category_id: category_id,
            filter_from: filter_from,
            filter_to: filter_to,
            tag: tag
        },
        success: function (response) {
            const category_news = response.category_news;

            $('#featuredNews').html(response.featured_news);

            if ($.trim(response.news_list) != "") {
                if (section_title) {
                    $('.newsArticles').prepend("<h2 class='newsCategoryTitle'>" + section_title + '</h2>');
                }

                $('.newsArticles').append('<div class="temp"></div>');

                $('.newsArticles').find('.temp ul li').unwrap();
                $('.newsArticles').find('.temp').hide();
                $('.newsArticles').find('.temp').append(response.news_list).fadeIn(animationSpeed, function () {
                    $(this).removeClass('temp');
                    $('#loadingOverlay').fadeOut();
                });
            }

            if (category_id || tag !== '' || filter_from || filter_to) {
                $.each(category_news, function(key, block) {
                    $('.' + key).hide();
                });

                $(".featuredNews").css("display", "none");
                $('.newsArticles').show();
            } else {
                $(".featuredNews").css("display", "flex");
                $('.newsArticles').hide();
            }

            $.each(category_news, function(key, block) {
                $('.' + key).append('<div class="temp"></div>');

                $('.' + key).find('.temp ul li').unwrap();
                $('.' + key).find('.temp').hide();
                $('.' + key).find('.temp').append(block).fadeIn(animationSpeed, function () {
                    $(this).removeClass('temp');
                    $('#loadingOverlay').fadeOut();
                });
            });

            lazyLoadedImages.update();
            $('.newsList li').matchHeight();

            last_page = $('.newsList li').last().data('last-page');

            if (last_page === last_page_result + 1) {
                $('.showMoreWrap').remove();
            }
        }
    }).done(function (response) {
        if ($.trim(response) === "") {
            $('#loadingOverlay').fadeOut();
            $('.showMoreWrap').fadeOut(800, function () {
                $(this).remove();
            });
        }
    });
}

/* ------------------------------ */
/* AJAX iframe forms  */
/* ------------------------------ */

window.submitIframeForm = function submitIframeForm(form) {
    "use strict";

    $(document).on('submit', form, function (e) {

        var iframe_body = '',
            response = '',
            formCache = $(this);

        formCache.prepend('<div id="loadingOverlay"></div>');
        formCache.find('#loadingOverlay').fadeIn();

        formCache.find('iframe').off('load');

        formCache.find('iframe').on('load', function () {

            iframe_body = this.contentDocument.body;

            response = $.parseJSON($(iframe_body).html());

            formValidation(formCache, response);
        });

    });
}

/* ------------------------------ */
/* Fix content height */

/* ------------------------------ */

window.matchBlockHeight = function matchBlockHeight(firstBlock, secondBlock) {
    'use strict';

    var $firstBlock = $(firstBlock),
        $secondBlock = $(secondBlock),
        firstBlockHeight,
        secondBlockHeight;

    if ($firstBlock.length) {

        $firstBlock.attr('style', '');
        $secondBlock.attr('style', '');

        if ($firstBlock.length && $secondBlock.length) {

            firstBlockHeight = $firstBlock.outerHeight();
            secondBlockHeight = $secondBlock.outerHeight();

            if (firstBlockHeight > secondBlockHeight) {
                $secondBlock.css({
                    'min-height': firstBlockHeight
                });
            } else {
                $firstBlock.css({
                    'min-height': secondBlockHeight
                });
            }
        }

        if ($(window).width() <= window.breakpoints.mobile) {
            $firstBlock.attr('style', '');
            $secondBlock.attr('style', '');
        }
    }
}

/* ------------------------------ */
/* News Article Loader  */

/* ------------------------------ */

window.createWaypoint = function createWaypoint(element_wrapper, time_out_speed, element, offset) {
    "use strict";

    $(element_wrapper).waypoint(function (direction) {
        if (direction === 'down') {

            var time_out = 100;

            $(element).each(function () {
                var $this = $(this);
                setTimeout(function () {
                    $this.addClass('actionTime');
                }, time_out);

                time_out = time_out + 250;
            });
        }
    }, {
        offset: offset
    });
}

window.pvFoundationLogosCarousel = function pvFoundationLogosCarousel() {

    if ($('.pvFoundationCarousel li').length > 0) {
        $('.pvFoundationCarousel').slick({
            infinite: true,
            slidesToShow: 4,
            slidesToScroll: 1,
            centerMode: false,
            arrows: true,
            prevArrow: '<i class="fa fa-chevron-left leftArrow"></i>',
            nextArrow: '<i class="fa fa-chevron-right rightArrow"></i>',
            draggable: true,
            centerPadding: '35px',
            dots: false,
            responsive: [
                {
                    breakpoint: 790,
                    settings: {
                        slidesToShow: 3,
                        centerMode: false,
                        cssEase: 'linear'
                    },
                    breakpoint: 540,
                    settings: {
                        slidesToShow: 2,
                        centerMode: false
                    }
                }
            ]
        });
    }
}

window.awardsCarousel = function awardsCarousel() {
    if ($('.listOfAwards li').length > 0) {

        $('.listOfAwards').slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true,
            prevArrow: '<i class="fa fa-chevron-left leftArrow"></i>',
            nextArrow: '<i class="fa fa-chevron-right rightArrow"></i>',
            responsive: [
                {
                    breakpoint: 670,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        cssEase: 'linear'
                    },
                }
            ]
        });
    }
}

/* ------------------------------ */
/* Featured items carousel in ajax tabs */

/* ------------------------------ */

window.tabsFeaturedItemsCarousel = function tabsFeaturedItemsCarousel() {

    if ($('.tabsContent .featuredItems li').length > 0) {
        $('.tabsContent .featuredItems').slick({
            infinite: true,
            slidesToShow: 4,
            slidesToScroll: 4,
            dots: false,
            prevArrow: '<i class="fa fa-chevron-left leftArrow"></i>',
            nextArrow: '<i class="fa fa-chevron-right rightArrow"></i>',
            responsive: [
                {
                    breakpoint: 900,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        infinite: true,
                        arrows: false,
                        dots: true
                    }
                }, {
                    breakpoint: 670,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: true,
                        centerMode: false,
                        dots: true,
                        variableWidth: true
                    }
                }, {
                    breakpoint: 450,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        cssEase: 'linear',
                        centerMode: false,
                        variableWidth: true,
                        dots: true
                    }
                }
            ]
        });

        $('.featuredItems h3').matchHeight();
        $('.featuredItems .features').matchHeight();

        $('.featuredItems .js_fixHeight').css("height", "");
        setTimeout(function () {
            $('.js_fixHeight').matchHeight();
        }, 500);

    }
}

/* ------------------------------ */
/* create a window and print */

/* ------------------------------ */

/*
 * Moving the search on the homepage only
 */

window.mobileHomeSearchMove = function mobileHomeSearchMove() {
    var move_point;

    if ($('.js_homeOnly').length) {
        move_point = 750;
    } else {
        move_point = window.breakpoints.mobile;
    }

    if ($(window).width() <= move_point) {
        if ($('.js_homepageSearchPosition').length) {
            $('#searchFormWrap').appendTo('.js_homepageSearchMobile');
        }
    } else {
        if ($('.js_homepageSearchPosition').length) {
            $('#searchFormWrap').appendTo('.js_homepageSearchPosition');
        }
    }
}

// redesign begin

window.stickyServiceCTABar = function stickyServiceCTABar() {

    $('.js_formBlock').waypoint({
        offset: function () {
            return -this.element.clientHeight
        },
        handler: function (direction) {
            if (direction === 'down') {
                $('body').addClass('stickyCTA');

                $('.servicesFormWrap').css({
                    'padding-top': $('.js_simpleCTAWrapper').outerHeight() + 20
                });
            }

            if (direction === 'up') {
                $('body').removeClass('stickyCTA');

                $('.servicesFormWrap').removeAttr('style');
            }
        }
    });
}

// function keywordSearch() {
//     var keyword_select = $('.js_keywordSearchSelect'),
//         with_chosen = keyword_select.chosen({
//             max_selected_options: 2,
//             display_selected_options: false
//         });
//
//     with_chosen.on('change', function () {
//         var $this = $(this),
//             current_value = $this.val(),
//             data_url = $this.find('option:selected').last().data('url');
//
//         // update results based on data url from search
//         $.ajax({
//             url: '/modules/Search/search_form_ajax.php?url=' + data_url + '&keyword_search=true',
//             beforeSend: function () {
//                 keyword_select.find('option').not(':selected').remove();
//             },
//             success: function (data) {
//                 // console.log(data.Make);
//                 var data_json = $.parseJSON(data);
//
//                 // console.log(data_json.search_form.Model);
//
//                 // $.each(data_json.search_form.Model, function(index, el) { //loop to check if the value exists inside the list
//                 //     var exists;
//                 //
//                 //     keyword_select.each(function(){
//                 //         console.log(this.value);
//                 //         console.log(el.display_name);
//                 //
//                 //         if (this.value == el.display_name) {
//                 //             exists = true;
//                 //         }
//                 //     });
//                 //
//                 //     if (!exists) {// if the value does not exists, added it to the list
//                 //         keyword_select.append("<option data-url="+el.url+">"+el.display_name+"</option>");
//                 //         with_chosen.trigger('chosen:updated');
//                 //     }
//                 // });
//                 //
//                 // // var ChosenInputValue = $('.chosen-choices input').val();//get the current value of the search
//                 // // $('.chosen-choices input').val(ChosenInputValue);//since the update method reset the input fill the input with the value already typed
//                 // // with_chosen.trigger('chosen:updated');//update the list
//
//                 $.each(data_json.search_form.Model, function (idx, obj) {
//                     // $('.chosen-results').append('<option data-url="' + obj.url + '">' + obj.display_name + '</option>');
//
//                     // $select_elem.append('<option value="' + obj.BU_ID + '">' + obj.BU_NAME + '</option>');
//
//                     var exists;
//
//                     // keyword_select.find('option').each(function(){
//                     //
//                     //     if ($(this).val() == obj.display_name) {
//                     //         exists = true;
//                     //     }
//                     // });
//
//                     // if (!exists) {
//                     //     keyword_select.append('<option data-url="' + obj.url + '">' + obj.display_name + '</option>');
//                     //     // $('.chosen-results').append('<li class="active-result">' + obj.display_name + '</li>');
//                     // }
//
//                     keyword_select.append('<option data-url="' + obj.url + '">' + obj.display_name + '</option>');
//                 });
//
//                 console.log(data_url);
//
//                 with_chosen.trigger('chosen:updated');
//             }
//         });
//     });
// }

window.subNavActive = function subNavActive() {
    "use strict";

    if (matchesMediaQuery(0, 670)) {
        $('.js_contentSidebar').addClass('activeSlideNav');
    } else {
        $('.js_contentSidebar').removeClass('activeSlideNav');
        $('.js_contentSidebar nav').css({
            display: ''
        });
    }
}
// redesign end
